module.exports = "/matchcenter-staging/assets/images/eurosport_1.c24aaf20ce9063f9e26b386b2be06057.png";